
(function() {
  const root = document.getElementById('goobs-header');
  if (!root) return;

  /* === Button press feedback === */
  root.addEventListener('keydown', (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      const btn = e.target.closest('.gh-btn, .gh-icon-btn');
      if (btn) btn.classList.add('is-pressed');
    }
  });
  root.addEventListener('keyup', (e) => {
    const btn = e.target.closest('.gh-btn, .gh-icon-btn');
    if (btn) btn.classList.remove('is-pressed');
  });

  /* === MENU DRAWER === */
  const menu = root.querySelector('#gh-menu');
  const openers = root.querySelectorAll('[data-action="open-menu"]');
  const closers = root.querySelectorAll('[data-action="close-menu"], .gh-menu__scrim');

  const openMenu = () => {
    if (!menu) return;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
  };
  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
  };

  openers.forEach(el => el.addEventListener('click', openMenu));
  closers.forEach(el => el.addEventListener('click', closeMenu));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });

  /* === CART BADGE === */
  const badge = root.querySelector('[data-cart-count]');
  function updateCartCount() {
    if (!badge) return;
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count || 0;
        badge.textContent = count;
        badge.classList.toggle('hidden', count === 0);
      })
      .catch(() => {});
  }
  updateCartCount();
  document.addEventListener('cart:refresh', updateCartCount);
})();
